import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '足球赛事', path: '/category/football' },
    { label: '篮球赛事', path: '/category/basketball' },
    { label: '电竞赛事', path: '/category/esports' },
    { label: '网球赛事', path: '/category/tennis' },
    { label: '综合赛事', path: '/category/comprehensive' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌介绍', path: '/about' },
    { label: '资质信誉', path: '/about' },
    { label: '联系我们', path: '/about' },
  ],
  help: [
    { label: '新手指南', path: '#' },
    { label: '常见问题', path: '/about' },
    { label: '用户协议', path: '#' },
    { label: '隐私政策', path: '#' },
    { label: '免责声明', path: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-lg text-white"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 tracking-wide">
                开云体育
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              开云体育是亚洲领先的综合性体育娱乐平台，持国际正规运营牌照，为全球体育爱好者提供安全、稳定、极速的一站式体育赛事服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-white transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">赛事导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              {footerLinks.help.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.path}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    {...(link.path.startsWith('#') ? { rel: 'nofollow' } : {})}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 开云体育 KaiYun Sports. 保留所有权利。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <span>客服邮箱：service@kaiyunsports.com</span>
              <span className="hidden sm:inline">|</span>
              <span>客服热线：+852 3008 8888</span>
            </div>
          </div>
          <p className="mt-3 text-xs text-background-600 text-center">
            温馨提示：请理性参与体育竞猜，量力而行。未满18周岁用户禁止参与竞猜活动。平台持有合法运营牌照，受国际监管机构监督。
          </p>
        </div>
      </div>
    </footer>
  );
}